/** Prefixed, collision-resistant ids using the platform CSPRNG. */
export const createId = (prefix: string): string => `${prefix}_${crypto.randomUUID()}`;
